<template #default>
    <div class="content-wrapper">
        <div class="content-block dx-card responsive-paddings">
            <DxForm id="form1" :form-data="incorporationData">
                <DxGroupItem :caption="$t('orders.manageOrders')" :col-count="1">
                    <DxSimpleItem name="ManageOrderGrid_">
                        <template #default>
                            <DxDataGrid id="ManageOrderGrid"
                                        :show-borders="true"
                                        :row-alternation-enabled="true"
                                        :hover-state-enabled="true"
                                        @row-updated="onUpdateCdp($event)"
                                        :data-source="ManageOrderData"
                                        ref="dataGridRefKey"
                                        key-expr="Id"
                                        @exporting="onExporting">
                                <DxColumn
                                    data-field="No"
                                    :caption="$t('orders.no')"
                                    :allow-editing="false">
                                </DxColumn>

                                <DxColumn data-field="OrderNumber"
                                          :caption="$t('orders.orderNumber')">
                                </DxColumn>

                                <DxColumn data-field="PayerName"
                                          :caption="$t('orders.payerName')" width="300">
                                </DxColumn>

                                <DxColumn data-field="CreatedOn" format="dd-MM-yyyy" data-type="date"
                                          :caption="$t('orders.createdOn')">
                                </DxColumn>

                                <DxColumn data-field="Status"
                                          :caption="$t('orders.ostatus')">
                                </DxColumn>

                                <DxColumn data-field="Currency"
                                          :caption="$t('orders.currency')">
                                </DxColumn>

                                <DxColumn data-field="Total"
                                    format="#,##0.##"
                                   :caption="$t('orders.totalPrice')">
                                </DxColumn>

                                <DxMasterDetail
                                    :enabled="true"
                                    template="masterDetailTemplate3"
                                />
                                <template #masterDetailTemplate3="{ data: data }">
                                    <detail-template
                                    :template-data="data"
                                    />
                                </template>

                                <DxColumnChooser :enabled="true" />
                                <DxColumnFixing :enabled="true" />
                                <!-- <DxFilterRow :visible="true" /> -->
                                <DxSearchPanel :visible="true" />
                                <DxGroupPanel :visible="true" />
                                <DxSelection mode="multiple" />
                                <DxExport
                                    :enabled="true"
                                    :formats="['pdf']"
                                    :allow-export-selected-data="true"
                                />

                                <DxSearchPanel location="before"
                                               :visible="true"
                                               :highlight-case-sensitive="true" />
                                <DxPager :show-page-size-selector="true" />
                                <DxPaging :page-size="10" />
                            </DxDataGrid>
                        </template>
                    </DxSimpleItem>
                </DxGroupItem>
            </DxForm>
        </div>
    </div>
</template>

<script>
    import DxForm, {
        DxGroupItem,
        DxSimpleItem,
        DxButtonItem,
        DxLabel,
        DxRequiredRule,
        DxCompareRule,
        DxRangeRule,
        DxStringLengthRule,
        DxPatternRule,
        DxEmailRule,
        DxAsyncRule,
    } from 'devextreme-vue/form'
    import DxItemPanel from "devextreme-vue/tab-panel"
    import DxAutocomplete from 'devextreme-vue/autocomplete'
    import {
        DxDataGrid,
        DxColumn,
        DxEditing,
        DxToolbar,
        DxItem,
        DxFormItem,
        DxLookup,
        DxExport,
        DxSelection,
        DxGrouping,
        DxPager,
        DxPaging,
        DxSearchPanel,
        DxLoadPanel,
        DxMasterDetail,
        DxColumnFixing,
        DxColumnChooser,
        DxFilterRow,
        DxGroupPanel,
    } from 'devextreme-vue/data-grid'

    import DetailTemplate from './template/order-detail-template.vue'

    import DxRadioGroup from 'devextreme-vue/radio-group'

    import DxButton from 'devextreme-vue/button'

    import notify from 'devextreme/ui/notify'

    import dateUtil from '@/helpers/dateUtil'

    import { jsPDF } from 'jspdf'
    import 'jspdf-autotable'
    import { exportDataGrid } from 'devextreme/pdf_exporter'
    import { Workbook } from 'exceljs'
    import { saveAs } from 'file-saver-es'

    import { mapState, mapActions } from 'vuex'
    import {
        POST_PURCHASE_ORDER, GET_PURCHASE_ORDER_LIST, GET_REVENUE_SOURCE
    } from '@/store/_actiontypes'

    const dataGridRefKey = "my-data-grid"

    export default {
        components: {
            DxGroupItem,
            DxSimpleItem,
            DxButtonItem,
            DxButton,
            DxRadioGroup,
            DxLabel,
            DxItemPanel,
            DxItem,
            DxDataGrid,
            DxColumn,
            DxEditing,
            DxFormItem,
            DxLookup,
            DxExport,
            DxSelection,
            DxPager,
            DxPaging,
            DxSearchPanel,
            DxMasterDetail,
            DxGrouping,
            DxLoadPanel,
            DxToolbar,
            DxItem,
            DxColumnFixing,
            DxFilterRow,
            DxColumnChooser,
            DxGroupPanel,
            DxRequiredRule,
            DxCompareRule,
            DxPatternRule,
            DxRangeRule,
            DxEmailRule,
            DxStringLengthRule,
            DxForm,
            DxAutocomplete,
            DxAsyncRule,
            DetailTemplate,
            notify,
        },

        data() {
            const incorporationData = {}
            return {
                dataOperation: ['New', 'Update'],
                selectedTabIndex: 0,
                isOrderVisible: true,
                dataGridRefKey,
                metaData: {},
                ManageOrderData: [],
                PrintColor: { 'color': '#6caddf', 'text-decoration': 'underline' },
                incorporationData
            }
        },

        computed: {
            ...mapState({
                payerId: state => state?.user?.user?.data?.payer?.id
            }),
            dataGrid: function () {
                return this.$refs.dataGridRefKey.instance
            },
            status() {
                return [
                    {
                        Id: true,
                        Name: this.$t('orders.status.active')
                    },
                    {
                        Id: false,
                        Name: this.$t('orders.status.inactive')
                    }
                ]
            },
            FacilityOptions() {
                return this.status
            },
            ProductOptions() {
                return this.status
            },
            buttonOptions() {
                return {
                    text: this.$t('orders.saveChanges'),
                    type: 'default',
                }
            }
        },

        mounted() {
            this.loadCampanies()
        },

        methods: {
            ...mapActions("payment", [
                  GET_PURCHASE_ORDER_LIST, GET_REVENUE_SOURCE
            ]),

            loadCampanies() {
                this.dataGrid.beginCustomLoading()
                let payload = {
                    payer_id: this.payerId,
                    appr_status: "",
                }
                this.GET_PURCHASE_ORDER_LIST(payload).then(res => {
                    let Items = res.data?.body[2]?.Items
                    this.ManageOrderData = res.data?.body[0]?.Sales.map((item, index) => {
                        return {
                            Id: index,
                            No: index+1,
                            OrderNumber: item.batch_no,
                            CreatedOn: item.created_at,
                            PayerName: item.payer_name,
                            Currency: item.ccy,
                            Total: Number(item.total),
                            Address: item.address,
                            PoDate: item.created_at,
                            BatchNo: item.batch_no,
                            Status: item.status,
                            Items: this.filterOrderByBatchNo(Items, item.batch_no)
                        }
                    })
                    this.dataGrid.endCustomLoading()
                })
                .catch(error => {
                    console.log(error)
                })
            },

            filterOrderByBatchNo(ItemsData, BatchNo) {
                let order_items = ItemsData.filter(item => item.batch_no === BatchNo)
                .map((item, index) => {
                    return {
                        item_name: item.item_name,
                        qty: item.qty,
                        rate: item.rate,
                        amount: item.amount,
                        ccy: item.ccy
                    }
                })
                return order_items
            },

            onExporting(e) {
                const doc = new jsPDF()
                exportDataGrid({
                    jsPDFDocument: doc,
                    component: e.component,
                    indent: 5,
                }).then(() => {
                    doc.save('Cdp.pdf')
                })
            },

            resetInputFiels() {
                this.RegisterOfMembersData = []
                this.CurrentMembersData = []
            },
        }
    }
</script>